import { Box } from '@mui/material';
import { PropsWithChildren } from 'react';

const ROOT_SX = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.75,
} as const;

const InterruptionTypeRoot = ({ children }: PropsWithChildren) => (
  <Box component="header" sx={ROOT_SX}>
    {children}
  </Box>
);

export default InterruptionTypeRoot;
